import styled from 'styled-components';

export const SidebarContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SidebarHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid #eee;
  font-weight: bold;
  font-size: 16px;
  color: #007cbf;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span:last-child {
    font-size: 12px;
    color: #999;
    font-weight: normal;
    margin-right: auto;
    padding-left: 20px;
  }
`;

export const SearchWrapper = styled.div`
  padding: 10px 20px;
`;

export const SearchInputContainer = styled.div`
  position: relative;

  svg {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 10px 12px 10px 35px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 13px;
  outline: none;

  &:focus {
    border-color: #007cbf;
  }
`;

export const LinesList = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const LineItem = styled.div<{ isSelected: boolean; lineColor: string }>`
  padding: 15px 20px;
  cursor: default;
  border-bottom: 1px solid #f9f9f9;
  background: ${props =>
    props.isSelected ? `${props.lineColor}10` : 'transparent'};
  border-left: 4px solid
    ${props => (props.isSelected ? props.lineColor : 'transparent')};
  transition: all 0.2s;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  position: relative;
`;

export const LineCheckboxWrapper = styled.div`
  margin-top: '3px';
  input {
    cursor: pointer;
    accent-color: #ccc;
  }
`;

export const LineInfo = styled.div`
  flex: 1;
`;

export const LineTitleRow = styled.div<{
  isSelected: boolean;
  lineColor: string;
}>`
  font-weight: bold;
  color: ${props => (props.isSelected ? props.lineColor : '#333')};
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ColorPickerLabel = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #999;

  input {
    opacity: 0;
    width: 0;
    height: 0;
    padding: 0;
    border: none;
    position: absolute;
  }
`;

export const LineDetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  font-size: 11px;
  color: #666;

  strong {
    color: #999;
  }

  div:last-child {
    grid-column: span 2;
  }
`;

export const InactiveToggleRow = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #666;

  input,
  label {
    cursor: pointer;
  }

  input {
    accent-color: #ccc;
  }
`;

export const MapSection = styled.div`
  flex: 1;
  height: 100%;
`;

export const SidebarWrapper = styled.div<{ isVisible: boolean }>`
  width: ${props => (props.isVisible ? '350px' : '45px')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  background: #fff;
  border-radius: 8px;
  margin-right: ${props => (props.isVisible ? '20px' : '10px')};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const ToggleSidebarButton = styled.button<{ isVisible: boolean }>`
  position: absolute;
  right: 5px;
  top: 18px;
  background: #f0f7ff;
  border: 1px solid #cce5ff;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  color: #007cbf;
  transition: transform 0.3s ease;
  transform: ${props => (props.isVisible ? 'rotate(0deg)' : 'rotate(180deg)')};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const SidebarContent = styled.div<{ isVisible: boolean }>`
  height: 100%;
  width: 350px;
  flex-shrink: 0;
  opacity: ${props => (props.isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
  pointer-events: ${props => (props.isVisible ? 'auto' : 'none')};
`;

export const NoResultsMessage = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    opacity: 0.5;
  }
`;

export const NoResultsIconContainer = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
`;
